import { setCookie, getCookie } from '../base/_utilities';

const announcementBar = document.getElementById('announcement_bar');
const announcementBarButton = document.getElementById('announcement_bar_button');

const init = function() {

	setupAnnouncementBar();

};

const setupAnnouncementBar = function() {

	if ( announcementBarButton && announcementBar ) {

		const announcementBarCookieID = ( announcementBar.getAttribute( 'data-apm-abar-cookie-id' ) ) ? announcementBar.getAttribute( 'data-apm-abar-cookie-id' ) : '';
		const announcementBarCookieDuration = ( announcementBar.getAttribute( 'data-apm-abar-cookie-duration' ) ) ? announcementBar.getAttribute( 'data-apm-abar-cookie-duration' ) : '';

		// If there is no cookie set to dismiss the bar remove the .is-dismissed class from the bar
		// and add body class for some addition top padding for the content
		if ( !getCookie( announcementBarCookieID ) ) {
			announcementBar.classList.remove('is-dismissed');
		}

		announcementBarButton.addEventListener( 'click', () => {
			setCookie( announcementBarCookieID, true, announcementBarCookieDuration )
			announcementBar.classList.add( 'is-dismissed' )
		} )

	}

}

const api = {
	init: init
};

export default api;